import {
  DndContext,
  closestCenter,
  DragEndEvent,
  DragOverlay
} from "@dnd-kit/core"
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove
} from "@dnd-kit/sortable"
import { useFormContext, useWatch } from "react-hook-form"
import { SortableEpisodeRow } from "./SortableEpisodeRow"
import { useState, memo } from "react"

export const EpisodeItemList = memo(() => {
  const { control, setValue } = useFormContext()
  const episodes = useWatch({
    control,
    name: "entities",
    defaultValue: []
  })

  const [activeEpisode, setActiveEpisode] = useState<any>(null)

  const handleDelete = (id: string) => {
    setValue(
      "entities",
      episodes.filter(e => e.id !== id),
      { shouldDirty: true }
    )
  }

  const moveEpisode = (from: number, to: number) => {
    if (to < 0 || to >= episodes.length) return
    setValue("entities", arrayMove(episodes, from, to), {
      shouldDirty: true
    })
  }

  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event
    setActiveEpisode(null)

    if (!over || active.id === over.id) return

    const oldIndex = episodes.findIndex(e => e.id === active.id)
    const newIndex = episodes.findIndex(e => e.id === over.id)

    moveEpisode(oldIndex, newIndex)
  }

  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragStart={e => {
        setActiveEpisode(
          episodes.find(ep => ep.id === e.active.id)
        )
      }}
      onDragEnd={onDragEnd}
    >
      <SortableContext
        items={episodes.map(e => e.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="max-h-[400px] overflow-y-auto space-y-3 pr-2 border rounded p-6">
          {episodes.map((ep, index) => (
            <SortableEpisodeRow
              key={ep.id}
              episode={ep}
              index={index}
              total={episodes.length}
              onDelete={handleDelete}
              onMoveUp={() => moveEpisode(index, index - 1)}
              onMoveDown={() => moveEpisode(index, index + 1)}
            />
          ))}
        </div>
      </SortableContext>

      {/* 🔥 DRAG GHOST */}
      <DragOverlay>
        {activeEpisode ? (
          <div className="p-3 border rounded bg-white shadow-lg">
            {activeEpisode.name}
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  )
})
